"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.digestTokenAccounts = exports.prepareTokenAccounts = exports.prepareTransaction = exports.hydrate = exports.preload = exports.modes = void 0;
var values_1 = __importDefault(require("lodash/values"));
// maintained union of all the modules
var compound = __importStar(require("./compound"));
var erc20 = __importStar(require("./erc20"));
var send = __importStar(require("./send"));
var erc721 = __importStar(require("./erc721"));
var erc1155 = __importStar(require("./erc1155"));
var modules = {
    erc20: erc20,
    compound: compound,
    send: send,
    erc721: erc721,
    erc1155: erc1155
};
exports.modes = {};
function loadModes() {
    for (var k in modules) {
        var m = modules[k];
        if (m.modes) {
            for (var j in m.modes) {
                exports.modes[j] = m.modes[j];
            }
        }
    }
}
loadModes();
function preload(currency) {
    return __awaiter(this, void 0, void 0, function () {
        var value, _a, _b, _i, k, m, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    value = {};
                    _a = [];
                    for (_b in modules)
                        _a.push(_b);
                    _i = 0;
                    _e.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 4];
                    k = _a[_i];
                    m = modules[k];
                    if (!m.preload) return [3 /*break*/, 3];
                    _c = value;
                    _d = k;
                    return [4 /*yield*/, m.preload(currency)];
                case 2:
                    _c[_d] = _e.sent();
                    _e.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, value];
            }
        });
    });
}
exports.preload = preload;
function hydrate(value, currency) {
    if (!value || typeof value !== "object")
        return;
    for (var k in value) {
        if (k in modules) {
            var m = modules[k];
            if (m.hydrate) {
                m.hydrate(value[k], currency);
            }
        }
    }
}
exports.hydrate = hydrate;
var prepareTransaction = function (account, transaction) {
    return (0, values_1["default"])(modules)
        // @ts-expect-error some module implement it
        .map(function (m) { return m.prepareTransaction; })
        .filter(Boolean)
        .reduce(function (p, fn) { return p.then(function (t) { return fn(account, t); }); }, Promise.resolve(transaction));
};
exports.prepareTransaction = prepareTransaction;
var prepareTokenAccounts = function (currency, subAccounts, address) {
    return (0, values_1["default"])(modules)
        // @ts-expect-error only exists in compound module. (type guard)
        .map(function (m) { return m.prepareTokenAccounts; })
        .filter(Boolean)
        .reduce(function (p, fn) { return p.then(function (s) { return fn(currency, s, address); }); }, Promise.resolve(subAccounts));
};
exports.prepareTokenAccounts = prepareTokenAccounts;
var digestTokenAccounts = function (currency, subAccounts, address) {
    return (0, values_1["default"])(modules)
        // @ts-expect-error only exists in compound module. (type guard)
        .map(function (m) { return m.digestTokenAccounts; })
        .filter(Boolean)
        .reduce(function (p, fn) { return p.then(function (s) { return fn(currency, s, address); }); }, Promise.resolve(subAccounts));
};
exports.digestTokenAccounts = digestTokenAccounts;
//# sourceMappingURL=index.js.map